module.exports = __webpack_public_path__ + "static/media/MurexinLogo.7240f271.svg";